import { render, staticRenderFns } from "./Gianos.vue?vue&type=template&id=5acfd5a3&scoped=true&"
import script from "./Gianos.vue?vue&type=script&lang=js&"
export * from "./Gianos.vue?vue&type=script&lang=js&"
import style0 from "./Gianos.vue?vue&type=style&index=0&id=5acfd5a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfd5a3",
  null
  
)

export default component.exports